import {
  NAV_TAB_KPI_USAGE,
  NAV_TAB_KPI_CRASHES,
  NAV_TAB_KPI_PERFORMANCE
} from '@/components/Mobile/mobile.constants';
import { MutationTree } from 'vuex';
import { State } from '@/store/modules/mobile/kpis/kpis.store';

const mutations: MutationTree<State> = {
  // setKpisTab(state, tabName) {
  //   switch (tabName) {
  //     case NAV_TAB_KPI_USAGE:
  //       state.currentTab = NAV_TAB_KPI_USAGE;
  //       break;
  //     case NAV_TAB_KPI_CRASHES:
  //       state.currentTab = NAV_TAB_KPI_CRASHES;
  //       break;
  //     case NAV_TAB_KPI_PERFORMANCE:
  //       state.currentTab = NAV_TAB_KPI_PERFORMANCE;
  //       break;
  //     default:
  //       state.currentTab = NAV_TAB_KPI_USAGE;
  //       break;
  //   }
  // },
  setCurrentEventMessage(state, data: any) {
    state.currentEventMessage = data.crashName;
  },
  setCurrentPerformanceErrorEventMessage(state, data: any) {
    state.currentEventMessage = data.errorName;
  },
  setCurrentHttpReqInfo(state, data: any) {
    state.currentHttpReqName = data.endpointName;
  },
  setCurrentCrashID(state, data: any) {
    state.currentCrashID = data;
  },
  setCurrentPerformanceID(state, data: any) {
    state.currentPerformanceID = data;
  },
  setCurrentLocationDetails(state, data: any) {
    state.currCountryCode = data.countryCode;
    state.currCountryName = data.countryName;
  },
  setCurrentPerfErrEventID(state, data: any) {
    state.currPerfErrEventID = data.eventId;
  }
};

export default mutations;
